<div class="waiver_popup">
    <div class="header_section">
        <p class="title">{{'waiver_popup_content.title'|cxTranslate}}</p>
        <button class="close-btn" aria-label="close dialog" mat-dialog-close>
            <img src="/icons/close-light-grey.svg" alt="" />
        </button>
    </div>
    <mat-dialog-content class="general-condition-content">
        <p>{{'waiver_popup_content.p1'|cxTranslate}}</p>
        <p class="mt-2">{{'waiver_popup_content.p2'|cxTranslate}}</p>
        <p class="mt-2">{{'waiver_popup_content.p3'|cxTranslate}}</p>
        <p class="mt-2">{{'waiver_popup_content.p4'|cxTranslate}}</p>
        <p class="mt-2">{{'waiver_popup_content.p5'|cxTranslate}}</p>
        <p>{{'waiver_popup_content.p6'|cxTranslate}}</p>
        <p class="user-info ">{{data?.firstName}} {{data?.lastName}} {{currentTime}}</p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button (click)="accept()" [disabled]="isAccepted"
            class="mat-raised-button mat-primary mat-accept">{{'common.waiver_button_accept' | cxTranslate }}</button>
    </mat-dialog-actions>
</div>